const colorSwatches = Array.from(document.querySelectorAll('.color-selector-container'));
const isListing = document.querySelector('[data-component-label="Product listing"');

const bindEvents = () => {
  colorSwatches.forEach((swatchRow) => {
    const swatches = Array.from(swatchRow.getElementsByTagName('li'));

    swatches.forEach((swatch) => {
      swatch.addEventListener('mouseenter', (e) => {
        onSwatchChange(e.target.firstElementChild, swatchRow);
      });
      swatch.addEventListener('mouseleave', (e) => {
        onSwatchChange(swatchRow.querySelector('li.active .tag-manager-color-variation'), swatchRow);
      });
    });
  });
};

const onSwatchChange = (swatch, swatchRow) => {
  swatchRow.querySelector('li .tag-manager-color-variation.active')?.classList.remove('active');
  if (swatch) {
    swatch.classList.add('active');
    // GroupedProductCard owns the images on grouped cards; their swatches point at SKUs with no image on the card.
    if (swatch.closest('.plp-color-swatches') && !swatch.closest('[data-variants]:not([data-variants=""])') && window.innerWidth > 991) {
      const activePimId = swatch.dataset.pimid;
      Array.from(swatch.closest('.isotope-item').querySelectorAll('img')).forEach((img) => {
        if (img.dataset.pimid === activePimId) img.classList.remove('d-none');
        else img.classList.add('d-none');
      });
    }
    if (isListing) {
      const pimid = swatch.dataset?.pimid;
      const articleTag = swatch.closest('article');
      articleTag.querySelectorAll('[data-product-badge-id]').forEach((div) => {
        div.classList.add('d-none');
      });
      const badgeDiv = document.querySelector(`[data-product-badge-id="${pimid}"`);
      if (badgeDiv) {
        badgeDiv.classList.remove('d-none');
      }
    }
  }
};

const init = () => {
  if (_THULEDATA.IsEditing) {
    return;
  }

  bindEvents();
};

document.addEventListener('DOMContentLoaded', function () {
  init();
});
